import { useEffect } from 'react';

import { canRestoreSharedState, decodeSharedParam } from '../utils/shareUtils';

export function useRestoreSharedTableState({
  shared,
  stateKey,
  isLoading,
  hasPermission,
  hasColumns,
  injectState,
  clearShared,
}: {
  shared?: string | null;
  stateKey: string;
  isLoading: boolean;
  hasPermission: boolean;
  hasColumns: boolean;
  injectState: (state: Record<string, unknown>) => void;
  clearShared: () => void;
}) {
  useEffect(() => {
    if (
      !stateKey ||
      !canRestoreSharedState({ isLoading, hasPermission, hasColumns })
    ) {
      return;
    }

    const decoded = decodeSharedParam(shared);
    if (decoded === undefined) {
      return;
    }

    if (decoded) {
      const tableState = decoded[stateKey];
      if (tableState && typeof tableState === 'object') {
        injectState(tableState as Record<string, unknown>);
      }
    }

    clearShared();
  }, [shared, stateKey, isLoading, hasPermission, hasColumns]);
}
